export default __webpack_public_path__ + "static/media/8.c7bc1187.svg";